process = (command, next) ->
  if command?.type is "url"
    { params: [{ target, url  }] } = command
    unless url.indexOf('http') is 0 or url.indexOf('#') is 0
      url = "http://#{url}"
    window.open(url, target)
  else
    next command

module.exports = { process, type: "url" }
